/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dataPoints.vue?vue&type=template&id=7ba4a1d1"
import script from "./dataPoints.vue?vue&type=script&lang=js"
export * from "./dataPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports